(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aliceparis-reviews"] && !Shopify.designMode) return;
  try {
    
  // The installed featured carousel supplies reviewer names, but no avatar node.
  // Its initials are a presentation detail derived from the visible Judge.me name.
  function decorateAliceParisReviewers(root) {
    root.querySelectorAll('.aliceparis-reviews--storewide .jdgm-carousel-item__reviewer-name-wrapper:not([data-reviewer-initial])').forEach((wrapper) => {
      const name = wrapper.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent?.trim();
      if (name) wrapper.dataset.reviewerInitial = Array.from(name)[0].toLocaleUpperCase();
    });
  }

  function initializeAliceParisReviewers() {
    decorateAliceParisReviewers(document);
    const observer = new MutationObserver(() => decorateAliceParisReviewers(document));
    document.querySelectorAll('.aliceparis-reviews--storewide').forEach((section) => {
      observer.observe(section, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAliceParisReviewers, { once: true });
  } else {
    initializeAliceParisReviewers();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
